import type { DataFromDroppoint, Store } from 'maps/types'

const DEFAULT_DISTANCE = 0.0

export function fromDroppoints(data: DataFromDroppoint): Store {
	validateData(data)
	const { deliveryPointId, address, name, ...details } = data
	return {
		details,
		id: deliveryPointId,
		collections: [],
		addresses: {
			address: name,
			streetAddress: address.streetAddress,
			city: address.city,
			postalCode: address.postalCode,
			shoppingCenter: null,
			coordinates: {
				distance: DEFAULT_DISTANCE,
				lat: address.coordinate.latitude,
				lng: address.coordinate.longitude,
			},
		},
	}
}

function validateData(data: DataFromDroppoint): void {
	if (!data || !data.deliveryPointId) {
		throw new Error('[Maps] Invalid data from droppoints')
	}
}
